function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6 0.733284C17.12 1.25328 17.12 2.09328 16.6 2.61328L13 6.21328L11.12 4.33328L14.72 0.733284C15.24 0.213284 16.0933 0.213284 16.6 0.733284ZM4.61331 16.3333H7.66664V8.87995L1.38664 2.61328C0.866639 2.09328 0.866639 1.25328 1.38664 0.733284C1.90664 0.213284 2.74664 0.213284 3.26664 0.733284L9.54664 6.99995C10.0533 7.50662 10.3333 8.17328 10.3333 8.87995V16.3333H13.3866C13.9866 16.3333 14.28 17.0533 13.8533 17.4666L9.46664 21.8533C9.19997 22.12 8.78664 22.12 8.51997 21.8533L4.13331 17.4666C3.71997 17.0533 4.01331 16.3333 4.61331 16.3333Z",
  fill: "#727981"
});

function SvgMergeIconBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeIconBig);
export default __webpack_public_path__ + "static/media/merge_icon_big.af541748.svg";
export { ForwardRef as ReactComponent };